import { render, staticRenderFns } from "./GeneralDialog.vue?vue&type=template&id=03131edd&scoped=true"
import script from "./GeneralDialog.vue?vue&type=script&lang=ts"
export * from "./GeneralDialog.vue?vue&type=script&lang=ts"
import style0 from "./GeneralDialog.vue?vue&type=style&index=0&id=03131edd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03131edd",
  null
  
)

export default component.exports